import { DrawingZone } from './@impl/DrawingZone.jsx';
import { func, string } from 'prop-types';

DrawingZone.propTypes = {
  zone_id: string.isRequired,
  className: string,
  onSizeChanged: func,
};

export { DrawingZone };
